<template>
  <div class="column is-7-desktop">
    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="save">저장하기</button>
    </div>
    <div class="box">
      <admin-box-item :title="boxTitle" :tip="boxTip" :titleFlex="true">
        <!-- 1차 -->
        <div v-for="(menu,idx) in eMenuData[type]" :key="'menu-'+idx">
          <div class="flex space-between align-center lp-table-row">
            <div :class="{'gray':disabledToggle(menu)}">{{ menu.name }}</div>
            <toggle-button @change="e => menu.enable = e.value"
                           :value="menu.enable"
                           :sync="true"
                           class="changed-font"
                           :width="70"
                           :height="24"
                           :disabled="disabledToggle(menu)"
                           :labels="{'checked':'활성화', 'unchecked':'비활성화'}"></toggle-button>
          </div>
          <div v-if="menu.enable">
            <!-- 2차 -->
            <div v-for="(child,child_idx) in menu.child" :key="'child-'+child_idx">
              <div class="flex space-between align-center lp-table-row">
                <div style="margin-left:20px" :class="{'gray':disabledToggle(child)}">┖ {{ child.name }}</div>
                <toggle-button @change="e => child.enable = e.value"
                               :value="child.enable"
                               :sync="true"
                               class="changed-font"
                               :width="70"
                               :height="24"
                               :disabled="disabledToggle(child)"
                               :labels="{'checked':'활성화', 'unchecked':'비활성화'}"></toggle-button>
              </div>
              <!-- 3차 -->
              <div v-if="child.enable">
                <div v-for="(gchild, gchild_idx) in child.child" :key="'gchild-'+gchild_idx">
                  <div class="flex space-between align-center lp-table-row">
                    <div style="margin-left:40px" :class="{'gray':disabledToggle(gchild)}">┖ {{ gchild.name }}</div>
                    <toggle-button @change="e => gchild.enable = e.value"
                                   :value="gchild.enable"
                                   :sync="true"
                                   class="changed-font"
                                   :width="70"
                                   :height="24"
                                   :disabled="disabledToggle(gchild)"
                                   :labels="{'checked':'활성화', 'unchecked':'비활성화'}"></toggle-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </admin-box-item>
    </div>

    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="save">저장하기</button>
    </div>
  </div>
</template>

<script>
  import SidebarMixin from "../../../mixins/SidebarMixin";

  export default {
    name: "menu-setting",
    mixins: [
      SidebarMixin
    ],
    data() {
      return {
        type: 'admin',
        // 백오피스 메뉴
        menuData: [],
        // 활성화 비활성화 메뉴
        eMenuData: {}
      }
    },
    created() {
      // this.getData();
    },
    computed: {
      boxTip () {
        let tip = '';
        if(this.type==='admin') tip = '관리자가 사용할 메뉴를 관리합니다. 활성화 메뉴를 선택해서 사용하고 싶은 메뉴를 설정하세요.';
        else tip = '파트너가 사용할 메뉴를 관리합니다. 활성화 메뉴를 선택해서 사용하고 싶은 메뉴를 설정하세요.';
        return tip
      },
      boxTitle () {
        let title = '';
        if(this.type==='admin') title = '관리자 메뉴 관리';
        else title = '파트너 메뉴 관리';
        return title
      }
    },
    watch: {
      async menus(n) {
        this.getData();
      }
      // '$route'(n) {
      //   this.getMenus();
      // }
    },
    methods: {
      getData () {
        if(this.$route.path.indexOf('adminmenu')>-1) this.type = 'admin';
        else this.type = 'partner'

        let url = '';
        if(this.type==='admin') url = 'admin/service/adminmenu';
        else url = 'admin/service/partnermenu';
        this.$axios.get(url).then(res=> {
          this.eMenuData = res.data;
          this.initMenu();
        })
      },
      async initMenu() {
        let menuPack = [];
        for(let i=0; i<this.menuPack.length; i++) {
          menuPack = menuPack.concat(this.menuPack[i].menu)
        }
        this.menuData = await this.getMenu(this.type);
        this.menuData = this.menuData.concat(this.cloneItem(this.menu_set.admin_marketing_menu));
        this.addEnable(this.menuData);
        this.menuData = this.cloneItem(this.menuData);
        if(this.eMenuData[this.type]) {
          this.setEnable1(this.menuData);
          this.eMenuData[this.type] = this.menuData;
        } else {
          let eMenuData = this.cloneItem(this.eMenuData);
          eMenuData[this.type] = this.menuData;
          this.eMenuData = eMenuData;
        }
      },
      setEnable1(menuData) {
        for (let i=0; i<menuData.length; i++) {
          let item = this.findMenu1(menuData[i].menu_id);
          if(item) menuData[i].enable = item.enable;
          if(menuData[i].child) {
            this.setEnable1(menuData[i].child)
          }
        }
      },
      findMenu1(menu_id) {
        let item = find(this.eMenuData[this.type], 'menu_id', menu_id);
        if(item) return item;
        else {
          for(let i=0; i<this.eMenuData[this.type].length; i++) {
            let child = this.eMenuData[this.type][i].child;
            if(child && child.length>0) {
              item = find(child, 'menu_id', menu_id);
              if(item) return item;
              else {
                for(let j=0; j<child.length; j++) {
                  let gchild = child[j].child;
                  if(gchild && gchild.length>0) {
                    item = find(gchild, 'menu_id', menu_id);
                    if(item) return item;
                  }
                }
              }
            }
          }
        }
        return item;
      },
      // enable 없는 경우 추가
      addEnable (menus) {
        for(let i=0; i<menus.length; i++) {
          // enable 없다면 추가
          if(Object.keys(menus[i]).indexOf('enable')===-1) {
            menus[i].enable = true;
          }
          let child = menus[i].child;
          if(Object.keys(menus[i]).indexOf('child')===-1) continue;
          else if(child.length>0) this.addEnable(child);
        }
      },
      save () {
        let url = '';
        if(this.type==='admin') url = 'admin/service/adminmenu';
        else url = 'admin/service/partnermenu';
        this.$axios.post(url, this.eMenuData).then(res=> {
          this.toast('저장되었습니다.')
        })
      },
      getDisabled(menus, target_menu_id) {
        let bool = menus.some(item=>{
          if(item.plugin && item.menu_id===target_menu_id) {
            // console.log(target_menu_id)
            return true;
          }
          if(item.child) {
            let bool_depth2 = item.child.some(child=>{
              if(child.plugin && child.menu_id===target_menu_id) {
                // console.log(target_menu_id)
                return true
              }
            })
            if(bool_depth2) return true
          }
        })
        return !!bool;
      },
      disabledToggle(menu) {
        let disabled = false;
        if(menu.plugin) {
          // 플러그인 메뉴일 경우 플러그인 유무에 따라 disabled 처리
          disabled = !this.isInternalPlugin(menu.plugin)
        } else {
          let menu_ids = menu.menu_id.split('.')
          // menu_id 마지막 키워드 삭제
          if(menu_ids.length>1) {
            menu_ids.splice(menu_ids.length-1, 1);
            let target_menu_id = menu_ids.join('.')
            disabled = this.getDisabled(this.eMenuData[this.type], target_menu_id)
          }
        }
        return disabled;
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .lp-table-row
    padding 6px 0
    border-bottom 1px solid rgb(152, 152, 152)
</style>
